import React from 'react'
import { useNavigation } from '@react-navigation/native'
import { useSelector } from 'react-redux'
import { StyleService, useStyleSheet } from '@src/style/service'
import { useUpsellOffer } from '@src/hooks/useUpsellOffer'
import { Storage } from '@src/utils'
import { useStorageValue } from '@src/utils/storage'
import { Feature, useFeatureFlag } from '@src/components/FeatureFlag'
import { userSelector } from '@src/selectors/app'
import { PromoBanner } from '@src/components/PromoBanner'
import { useIsDexcomPartnerUser } from '@src/hooks/useIsDexcomPartnerUser'
import { useGetByosVideoCallUpsellNextStep } from '../../hooks'

export const UpgradeSubscriptionBanner = () => {
  const styles = useStyleSheet(themedStyle)
  const navigation = useNavigation()

  const upsellOffer = useUpsellOffer()

  const user = useSelector(userSelector)
  const isDexcomUser = useIsDexcomPartnerUser()
  const notificationInboxEnabled = useFeatureFlag(Feature.NotificationInbox)

  const nextByosVideoCallsUpsellStep = useGetByosVideoCallUpsellNextStep()

  const [closedUpgradeSubscriptionBanner, setClosedUpgradeSubscriptionBanner] = useStorageValue(
    `${Storage.UPGRADE_SUBSCRIPTION_BANNER_VISITED_KEY}_${upsellOffer?.billingProduct}_${user?.id}`,
  )

  if (notificationInboxEnabled) {
    return null
  }

  if (isDexcomUser) {
    return null
  }

  if (closedUpgradeSubscriptionBanner) {
    return null
  }

  if (nextByosVideoCallsUpsellStep) {
    // so we don't show the conflicting banner
    return null
  }

  if (!upsellOffer) {
    return null
  }

  const onPress = () => {
    navigation.navigate('ProductExplanation', {
      upsellOffer,
    })
  }

  const onClose = () => {
    setClosedUpgradeSubscriptionBanner(true)
  }

  return (
    <PromoBanner
      badgeText={upsellOffer.badge}
      onPress={onPress}
      accessibilityLabel="Upgrade Subscription"
      title={upsellOffer.title}
      descriptionMarkdown={upsellOffer.descriptionMarkdown}
      iconName="x"
      onIconPress={onClose}
      iconAccessibilityLabel="Close Upgrade Subscription Banner"
      style={styles.container}
    />
  )
}

const themedStyle = StyleService.create({
  container: {
    marginVertical: 12,
    marginHorizontal: 16,
  },
})
